// extracted by mini-css-extract-plugin
module.exports = {"AthletePollResponse":"AthletePollResponse_AthletePollResponse__30QGz","avatar":"AthletePollResponse_avatar__3sBsw","date":"AthletePollResponse_date__2xsRB"};